<template>
  <div>
    <div class="card z-depth-3 pb-4" v-if="user">

      <div>
        <div>
          <img
            class="w-full object-cover"
            src="https://homesby360.s3.amazonaws.com/bg2.jpg"
            alt="homesby360"
          />
        </div>
        <div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="-mt-12 sm:-mt-16 sm:flex sm:items-end sm:space-x-5">
            <div class="flex">
              <img
                class="h-24 w-24 rounded-full ring-4 ring-white sm:h-32 sm:w-32 object-cover"
                src="../../../assets/Nicola.png"
                alt="RealtorImage"
              />

              <div class="mt-12 sm:mt-16 ml-4">
                <h1
                  class="text-lg sm:text-2xl font-bold text-gray-700 truncate"
                >
                  Nicola Burger (Realtor) <br />
                  <button
                    type="button"
                    class="hidden inline-flex items-center px-3 py-1.5 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-full text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  >
                    <i class="fas fa-play-circle -ml-0.5 mr-2 h-4 w-4"></i>
                    Watch Intro
                  </button>
                </h1>
              </div>
            </div>

            <div class="sm:mb-6">
              <nav class="sm:space-x-4 space-y-2 p-2" aria-label="Tabs">
                <button
                  @click="showDashboard"
                  class="w-full sm:w-auto  bg-white rounded-full text-gray-700 shadow-md hover:text-gray-700 hover:shadow-lg py-2 px-2 font-light text-sm"
                >
                  <span
                    ><i class="text-green-600  fas fa-home fa-home mr-1"></i>
                    Dashboard</span
                  >
                </button>

                <button
                  @click="displayListings"
                  class="w-full sm:w-auto bg-white rounded-full text-gray-700 shadow-md hover:text-gray-700 py-2 hover:shadow-lg px-2 font-light text-sm"
                >
                  <span
                    ><i class="text-blue-500 fas fa-search mr-1"></i>Search
                    Homes</span
                  >
                </button>

                <button
                  @click="showDocs"
                  class="w-full sm:w-auto bg-white rounded-full text-gray-700 shadow-md hover:text-gray-700 hover:shadow-lg py-2 px-2 font-light text-sm"
                >
                  <span
                    ><i class="text-gray-600 fas fa-user mr-1"></i> Edit
                    Profile</span
                  >
                </button>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-1">
      <v-stepper :dark="documents == '' ? false : true" non-linear>
        <!-- <v-alert
          v-if="user.notifications.length > 0"
          class="my-4 text-sm m-1 text-center"
          dense
          text
        >
          <i class="far fa-question-circle"></i> You have updated your
          <strong>profile information</strong>. Do you want to do the same with
          your <strong>documents</strong>?
          <button
            @click="updateSubmissions()"
            class="ml-2 bg-green-700 text-white animate-pulse font-bold  rounded-full px-2 py-1"
          >
            CLICK HERE
          </button>
        </v-alert> -->

        <v-stepper-header v-if="user.type == 'Buyer'">
          <v-divider></v-divider>
          <v-stepper-step
            v-for="item in items.slice(0, 4)"
            :key="item.id"
            :editable="isSub"
            :step="item.id"
            @click="isSub ? displayDocs(item) : false"
          >
            <span
              :class="
                hideButton == false && item.name == 'Agency'
                  ? 'pulse-button rounded-lg text-white animate-pulse px-2'
                  : ''
              "
              >{{ item.name }}
            </span>
          </v-stepper-step>
          <v-divider></v-divider>
        </v-stepper-header>


        <v-stepper-header v-else-if="user.type == 'Management'">
          <v-divider></v-divider>
          <v-stepper-step
            v-for="item in items.slice(4, 5)"
            :key="item.id"
            :editable="isSub"
            :step="item.id"
            @click="isSub ? displayDocs(item) : false"
          >

            <span
              :class="
                hideButton == false && item.name == 'Management Agreement'
                  ? 'pulse-button rounded-lg text-white animate-pulse px-2'
                  : ''
              "
              >{{ item.name }}
            </span>
          </v-stepper-step>
          <v-divider></v-divider>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content class="px-0 py-2" :step="stepValue">
            <template v-if="menuType == 'Sample Documents'">
              <div class="flex flex-col mt-2 p-2">
                <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div
                    class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
                  >
                    <div
                      class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
                    >
                      <table class="min-w-full divide-y divide-gray-200">
                        <thead class="bg-gray-100">
                          <tr>
                            <th
                              scope="col"
                              class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                              Document Name
                            </th>
                          </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-gray-200">
                          <tr v-for="doc in documents" :key="doc.id">
                            <td class="px-6 py-4 whitespace-nowrap flex">
                              <div class="flex items-center">
                                <div
                                  class="hidden sm:block sm:flex-shrink-0 h-10 w-10"
                                >
                                  <img
                                    class="h-10 w-10 rounded-full"
                                    :src="urlLogo + doc.doc_name.name + rest"
                                    alt=""
                                  />
                                </div>
                                <div class="sm:ml-4">
                                  <div
                                    class="text-sm font-medium text-gray-900"
                                  >
                                    <v-menu
                                      open-on-hover
                                      bottom
                                      offset-y
                                      :close-on-content-click="
                                        closeOnContentClick
                                      "
                                    >
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <span v-bind="attrs" v-on="on">
                                          {{ doc.doc_name.name }}
                                        </span>
                                      </template>

                                      <template v-if="doc.disabled">
                                        <lender :docId="doc" :user="user">
                                        </lender>
                                      </template>
                                    </v-menu>
                                  </div>
                                  <div class="text-sm text-gray-500">
                                    <v-tooltip max-width="500" bottom>
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <span v-bind="attrs" v-on="on"
                                          >{{
                                            doc.doc_name.description
                                              | shortText(30)
                                          }}...</span
                                        >
                                      </template>
                                      <span>{{
                                        doc.doc_name.description
                                      }}</span>
                                    </v-tooltip>
                                  </div>
                                </div>
                              </div>

                              <div>
                                <v-btn
                                  x-small
                                  rounded
                                  color="#2196F3"
                                  target="_blank"
                                  :href="url2 + doc.document_name"
                                  dark
                                >
                                  Open</v-btn
                                >
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <template v-else>
              <div
                v-for="(doc, index) in documents"
                :key="index"
                class="grid gap-4 grid-cols-1 sm:grid-cols-3 p-2 text-center"
              >
                <div
                  v-if="isAdmin"
                  class="text-white text-center col-span-full sm:flex justify-center gap-y-2 sm:gap-0"
                >
                  <v-btn
                    :disabled="disabledSub(doc.id)"
                    @click="getFillable(doc, url + submissionName.file_name)"
                    rounded
                    color="#2196F3"
                    class="mt-2 text-white text-center"
                  >
                    <i class="fas fa-edit"></i> edit Submission
                  </v-btn>

                  <v-btn
                    v-if="!isCode"
                    rounded
                    color="purple"
                    class="mt-2 sm:ml-2"
                    @click="generateCode(user.email)"
                  >
                    Prepare Document for Signature
                  </v-btn>

                  <v-btn
                    @click="moreInfo = !moreInfo"
                    v-else
                    rounded
                    color="success"
                    class="mt-2 text-white text-center sm:ml-2"
                  >
                    <i class="fas fa-check-circle"></i> Send for Signature
                  </v-btn>

                  <template
                    v-if="
                      agencyStatus.status == 'signed' &&
                        agencyStatus.menu_name == 'Agency'
                    "
                  >
                    <!-- @click="terminateAgency(agencyStatus, doc)" -->
                    <v-btn
                      :loading="showLoading"
                      rounded
                      color="error"
                      class="mt-2 text-white text-center sm:ml-2"
                    >
                      <i class="fas fa-edit"></i> Terminate Agency
                    </v-btn>
                  </template>

                  <template
                    v-else-if="agencyStatus.menu_name == 'Offer to Purchase'"
                  >
                    <v-btn
                      @click="terminateOffer(agencyStatus, doc)"
                      v-if="!showSuccess"
                      :loading="showLoading"
                      rounded
                      color="error"
                      class="mt-2 text-white text-center sm:ml-2"
                    >
                      <i class="fas fa-edit"></i> Terminate Submission
                    </v-btn>
                    <v-chip
                      v-else
                      class="mt-2 text-white text-center sm:ml-2"
                      color="green"
                      text-color="white"
                    >
                      Successfully Terminated
                    </v-chip>
                  </template>
                </div>

                <div
                  v-if="moreInfo"
                  class="mt-2 p-2 rounded-lg bg-gray-200 col-span-full grid gap-x-2 grid-cols-1 sm:grid-cols-2"
                >
                  <div
                    class="col-span-2 border-2 border-gray-300 border-dashed bg-white rounded-lg p-2 flex flex-wrap content-center justify-center hover:border-gray-400"
                  >
                    <div class="text-center">
                      <button
                        @click="addMore = true"
                        type="button"
                        class="inline-flex items-center shadow-sm px-4 py-1.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50 focus:outline-none"
                      >
                        <!-- Heroicon name: solid/plus-sm -->
                        <svg
                          class="-ml-1.5 mr-1 h-5 w-5 text-gray-400"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <span>Add Recipients (Optional)</span>
                      </button>

                      <button
                        v-if="!disabledButton"
                        :disabled="disabledButton"
                        @click="sendForSignature(doc)"
                        type="button"
                        class="disable:opacity-50 uppercase ml-2 inline-flex items-center shadow-sm px-4 py-1.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-white bg-green-600 hover:bg-green-700 focus:outline-none"
                      >
                        <svg
                          class="-ml-1.5 mr-1 h-5 w-5 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <span>Send</span>
                      </button>
                      <span
                        v-else
                        class="uppercase ml-2 inline-flex items-center px-4 py-2 rounded-full text-xs font-medium bg-blue-600 text-white"
                      >
                        Processing...
                      </span>

                      <div
                        v-if="
                          recipients[0].name !== '' &&
                            recipients[0].email !== ''
                        "
                        class="flex mt-2 bg-green-50 w-full px-2 rounded-md"
                      >
                        <div class="flex-shrink-0 mt-2">
                          <!-- Heroicon name: solid/check-circle -->
                          <svg
                            class="h-5 w-5 text-green-400"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                        <div class="ml-2 mt-2">
                          <p class="text-sm font-medium text-green-800">
                            Successfully added
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-if="!isAdmin"
                  class="bg-gray-100 p-1 rounded-md  col-span-3"
                >
                  <div
                    class="max-w-7xl mx-auto py-6 px-4 sm:py-16 sm:px-6 lg:px-8"
                  >
                    <div class="text-center">
                      <p
                        class="text-2xl font-extrabold text-gray-900 sm:text-4xl sm:tracking-tight lg:text-5xl"
                        v-html="
                          doc.doc_name ? doc.doc_name.name : doc.document_name
                        "
                      ></p>

                      <p
                        :class="
                          doc.doc_name
                            ? 'max-w-xl mt-2 mx-auto text-base text-gray-500'
                            : 'inline-flex items-center text-base px-2.5 py-0.5 rounded-full text-xs font-medium bg-pink-100 text-pink-600'
                        "
                        v-html="
                          doc.doc_name
                            ? doc.doc_name.description
                            : 'Your Realtor is reviewing your information...'
                        "
                      ></p>

                      <p
                        v-if="doc.disabled == '0'"
                        class="disabled:opacity-50 mt-4 text-gray-500"
                      >
                        <template
                          v-if="doc.document_name.includes('Offer')"
                        ></template>
                        <template v-else>
                          <template v-if="hideButton">
                            Ready to Sign?
                            <!-- :disabled="docsOpen ? true : false" -->
                            <v-btn
                              elevation="2"
                              @click="displayPolicy(doc)"
                              rounded
                              color="purple"
                              class="text-white"
                            >
                              <i class="fas fa-signature"></i> Signature
                            </v-btn>
                          </template>
                          <span
                            v-else
                            class="inline-flex items-center text-base px-2.5 py-0.5 rounded-full text-xs font-medium bg-pink-100 text-pink-600"
                          >
                            Your Realtor is reviewing your information...
                          </span>
                        </template>
                        <v-dialog v-model="showPolicy" width="600">
                          <v-card>
                            <v-card-title class="text-h5 grey lighten-2">
                              Signing Documents
                            </v-card-title>

                            <v-card-text class="mt-4">
                              Clicking "Continue" will send an alert to your
                              REALTOR to review your account and send the
                              document(s) to your email for signature.

                              <v-expansion-panels
                                class="mt-4"
                                v-if="checkProfile"
                              >
                                <v-expansion-panel>
                                  <v-expansion-panel-header
                                    class="text-blue-600"
                                    color="#E3F2FD"
                                    >Add Spouse
                                    (Optional)</v-expansion-panel-header
                                  >
                                  <v-expansion-panel-content>
                                    <spouse
                                      :user="user"
                                      :hideText="true"
                                    ></spouse>
                                  </v-expansion-panel-content>
                                </v-expansion-panel>
                              </v-expansion-panels>
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                :loading="valueLoading"
                                color="primary"
                                text
                                @click="alertAdmin"
                              >
                                Continue
                              </v-btn>
                              <v-btn
                                color="secondary"
                                text
                                @click="showPolicy = false"
                              >
                                Cancel
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </p>

                      <div v-else v-for="track in doc.trackers" :key="track.id">
                        <span
                          class="inline-flex items-center text-base px-2.5 py-0.5 rounded-full text-xs font-medium bg-pink-100 text-pink-600"
                          v-if="track.status === 'request_signature'"
                        >
                          Your Realtor is reviewing your information...
                        </span>
                        <span
                          class="inline-flex items-center text-base px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-600"
                          v-else-if="track.status === 'email_sent'"
                        >
                          Please check your email address.
                        </span>

                        <span
                          class="inline-flex items-center text-base px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-600"
                          v-else-if="track.status === 'signed'"
                        >
                          Document complete
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div id="toolbar" class="col-span-3 text-center">
                  <embed
                    v-if="doc.file_name"
                    controls="false"
                    :src="url + doc.file_name"
                    class="hidden sm:block"
                    width="100%"
                    height="1000"
                    type="application/pdf"
                  />
                  <!-- <embed v-else controls="false" :src="url2 + doc.document_name" width="100%" height="600" type="application/pdf" /> -->
                  <a
                    type="button"
                    :href="url + doc.file_name"
                    target="_blank"
                    class="animate-bounce inline-flex sm:hidden  items-center px-4 py-2 text-xs font-medium rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none"
                  >
                    Open Document
                  </a>
                </div>
              </div>
            </template>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>

    <v-dialog
      v-if="dialog"
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <dialog-update
        @update="getUser"
        @clicked="closeDocModalFinal"
        :singleDoc="singleDoc"
      ></dialog-update>
    </v-dialog>

    <v-dialog
      v-if="dialog2"
      v-model="dialog2"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <dialog-create
        @update="getUser"
        @clicked="closeDocModal"
        :singleDoc="singleDoc"
      ></dialog-create>
    </v-dialog>

    <v-dialog
      v-if="arraySub"
      v-model="arraySub"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="#424242">
          <v-btn icon dark @click="closeDialogSub()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <!-- <v-toolbar-title>Settings</v-toolbar-title> -->
        </v-toolbar>

        <v-row>
          <v-col cols="12" md="6">
            <embed
              :src="url + submissionName.file_name"
              width="100%"
              height="1200"
              type="application/pdf"
            />
          </v-col>

          <v-col cols="12" md="6" class="p-4">
            <v-divider></v-divider>

            <v-form id="mySubmission">
              <div class="form-group">
                <div
                  class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
                >
                  <div
                    v-for="(single, index) in arraySubmission"
                    :key="index"
                    class="sm:col-span-3"
                  >
                    <template
                      v-if="
                        single.type === 'PDFTextField' ||
                          single.type === 'PDFSignature'
                      "
                    >
                      <label
                        for="first_name"
                        class="block text-sm font-medium text-gray-600"
                      >
                        {{ single.name }}
                        <small class="ml-1 text-gray-400"
                          >({{ single.type }})</small
                        >
                      </label>

                      <input
                        type="text"
                        :name="single.name"
                        :value="single.value"
                        class="disabled:opacity-50 text-indigo-500 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md p-2"
                      />
                    </template>

                    <template v-else-if="single.type === 'PDFCheckBox'">
                      <label
                        for="checks"
                        class="block text-sm font-medium text-gray-600"
                      >
                        {{ single.name }}
                        <small class="ml-1 text-gray-400"
                          >({{ single.type }})</small
                        >
                      </label>

                      <input
                        type="checkbox"
                        :checked="single.value ? true : false"
                        :name="single.name"
                        :value="single.value"
                        class="disabled:opacity-50 block sm:text-sm border border-gray-300 rounded-md p-2"
                      />
                    </template>
                  </div>
                </div>
              </div>

              <v-btn
                @click.prevent="editSubmission(submissionName)"
                rounded
                type="submit"
                small
                class="text-white"
                color="#0D47A1"
              >
                Save Changes
              </v-btn>
            </v-form>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <div
      v-if="addMore"
      class="fixed z-10 inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <div
          class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity"
          aria-hidden="true"
        ></div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >

        <div
          class="inline-block align-center bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"
        >
          <div
            v-for="(rec, k) in recipients"
            :key="k"
            class="mt-6 grid grid-cols-1 gap-2 sm:grid-cols-6"
          >
            <div class="sm:col-span-3">
              <label
                for="first_name"
                class="block text-sm font-medium text-gray-700"
              >
                Name
              </label>
              <div class="mt-1">
                <input
                  v-model="rec.name"
                  type="text"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md p-2 border"
                />
              </div>
            </div>

            <div class="sm:col-span-3">
              <label
                for="last_name"
                class="block text-sm font-medium text-gray-700"
              >
                Email
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  v-model="rec.email"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md p-2 border"
                />
              </div>
            </div>
            <div class="sm:col-span-6">
              <span
                @click="remove(k)"
                v-show="k || (!k && recipients.length > 1)"
                class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800"
              >
                <i class="fas fa-minus-circle mr-1"></i>Remove
              </span>
              <span
                @click="add(k)"
                v-show="k == recipients.length - 1"
                class="ml-1 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
              >
                <i class="fas fa-plus-circle mr-1"></i> Add Recipients
              </span>
            </div>
          </div>

          <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <button
              @click="addMore = false"
              cltype="button"
              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
            >
              Save
            </button>
            <!-- @click="closeAddedEmails" -->
            <button
              type="button"
              @click="addMore = false"
              class="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>

<script>
import Swal from "sweetalert2";
import moment from "moment";
import Spouse from "./Spouse.vue";
import Lender from "./Lender.vue";
import DialogUpdate from "../../Admin/DialogUpdate.vue";
import DialogCreate from "../../Admin/DialogCreate.vue";
import { PDFDocument, PDFTextField, PDFSignature, PDFCheckBox } from "pdf-lib";
export default {
  props: ["user"],
  components: { Lender, Spouse, DialogCreate, DialogUpdate },
  data() {
    return {
      url: process.env.VUE_APP_API_URL_FILES,
      url2: process.env.VUE_APP_API_URL_S3,
      showTool: false,
      closeOnContentClick: false,
      dialog: false,
      dialog2: false,
      singleDoc: "",
      urlLogo: "https://ui-avatars.com/api/?name=",
      rest: "&background=cdcdcd&color=fff",
      e1: 1,
      showPolicy: false,
      items: [],
      stepValue: 1,
      documents: "",
      menuType: "",
      selectedSubmission: "",
      valueLoading: false,
      arraySubmission: [],
      arraySub: false,
      submissionName: "",

      moreInfo: false,

      addMore: false,
      recipients: [
        {
          name: "",
          email: ""
        }
      ],

      hideButton: true,
      disabledButton: false,

      docsOpen: true,
      agencyStatus: "",
      showSuccess: false,
      showLoading: false
    };
  },

  filters: {
    shortText(value, limit) {
      if (value) {
        return value.substring(0, limit);
      }
    }
  },

  created() {
    this.getMenuItems();
  },

  mounted() {
    //  window.Echo.channel("get-client").listen("ClientStatus", () => {
    //    window.location.reload();
    //    this.$router.push({ name: "BuyerDashboard" });
    //  });

    if (this.$route.params.submission) {
      let newSub = [];
      newSub.push(this.$route.params.submission);
      this.documents = newSub;
    }

    // if(localStorage.userRole == 'user'){
    window.Echo.channel("updated-sub").listen("UpdatedSubmission", () => {
      window.location.reload();
      this.$router.push({ name: "BuyerDashboard" });
    });
    // }

    if (this.$route.params.openDocs) {
      //this.docsOpen = this.$route.params.openDocs;
      let submissions = this.user.submissions;
      let newSub = [];
      newSub.push(submissions[7]);
      this.documents = newSub;
      //this.docsOpen = true;
    }

    if (this.$route.params.status) {
      this.agencyStatus = this.$route.params.status;
    }
  },

  computed: {
    getMenu() {
      return this.items;
    },

    isSub() {
      if (this.$route.params.submission) {
        return false;
      } else {
        return true;
      }
    },

    isCode() {
      if (localStorage.code) {
        return true;
      }
      return false;
    },

    isAdmin() {
      if (localStorage.userRole === "admin") {
        return true;
      }
      return false;
    },

    checkProfile() {
      if (this.user) {
        if (
          !this.user.profile.spouse_name ||
          !this.user.profile.spouse_email ||
          !this.user.profile.spouse_phone
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },

  methods: {
    terminateOffer(menu, doc) {
      this.showLoading = true;
      window.axios
        .post("api/terminateSub", {
          trackerId: menu.id,
          subId: doc.id,
          userName: this.user.name
        })
        .then(() => {
          this.$store.dispatch("getUser");
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Offer successfully terminated",
            showConfirmButton: false,
            timer: 4000
          });
          this.showLoading = false;
          this.showSuccess = true;
        });
    },

    terminateAgency(menu, doc) {
      this.showLoading = true;
      window.axios
        .post("api/terminateAgency", {
          trackerId: menu.id,
          subId: doc.id,
          userName: this.user.name
        })
        .then(() => {
          this.$store.dispatch("getUser");
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Agency successfully terminated",
            showConfirmButton: false,
            timer: 4000
          });
          this.showLoading = false;
        });
    },

    displayDocs(menu) {
      this.hideButton = true;
      //this.docsOpen = false;
      if (this.user) {
        let submissions = this.user.submissions;
        let docIds = [];
        menu.documents.forEach(el => {
          submissions.find(doc => {
            if (doc.document_id == el.id) {
              docIds.push(doc);
            }
          });
        });

        this.documents = docIds;
        this.menuType = menu.name;
        this.stepValue = menu.id;
      }
    },

    displayListings() {
      this.$router.push({ name: "listings" });
    },

    showDocs() {
      this.$emit("showWelcome");
    },

    showDashboard() {
      this.$emit("showDashboard");
    },

    async getFillable(doc, subUrl) {
      console.log(subUrl);
      // Fetch the PDF with form fields
      //const formUrl = this.url + doc.file_name;
      this.submissionName = doc;
      const dataApi = await window.axios.get("/api/dataApi/" + doc.file_name, {
        responseType: "arraybuffer"
      });

      console.log("data: " + dataApi.data);

      // //const formUrl = 'https://pdf-lib.js.org/assets/dod_character.pdf';
      // const formPdfBytes = await fetch(formUrl).then(res => res.arrayBuffer());

      // Load a PDF with form fields
      const pdfDoc = await PDFDocument.load(dataApi.data);
      console.log("pdfDoc: " + pdfDoc);
      // Get the form containing all the fields
      const form = pdfDoc.getForm();
      console.log("forms: " + form);
      const nameField = form.getFields();
      console.log("nameField: " + nameField);

      nameField.forEach(field => {
        console.log(field.constructor.name, field.getName());

        if (field instanceof PDFTextField) {
          this.arraySubmission.push({
            type: "PDFTextField",
            name: field.getName(),
            value: field.getText()
          });
        } else if (field instanceof PDFCheckBox) {
          //console.log(field.isChecked())
          this.arraySubmission.push({
            type: "PDFCheckBox",
            name: field.getName(),
            value: field.isChecked()
          });
        } else if (field instanceof PDFSignature) {
          this.arraySubmission.push({
            type: "PDFSignature",
            name: field.getName()
          });
        }

        // if(field.constructor.name == 'PDFTextField'){
        //   value.concat(field.getTextField(field.getName()));
        // }else if(field.constructor.name == 'PDFCheckBox'){
        //    value.concat(field.check());
        // }
      });

      this.arraySub = true;
    },

    generateCode(email) {
      window.location.href =
        process.env.VUE_APP_DEMO_ACCOUNT_BASE_URL +
        "?response_type=code&scope=signature&client_id=" +
        process.env.VUE_APP_NEW_CLIENT_ID +
        "&redirect_uri=" +
        process.env.VUE_APP_DEMO_ACCOUNT_URI;

      localStorage.setItem("email", email);
      localStorage.setItem("code", true);
    },

    add() {
      this.recipients.push({
        name: "",
        email: ""
      });
      console.log(this.recipients);
    },

    remove(index) {
      this.recipients.splice(index, 1);
    },

    closeAddedEmails() {
      this.recipients = [{ name: "", email: "" }];
      this.addMore = false;
    },

    closeDialogSub() {
      this.arraySubmission = [];
      this.submissionName = "";
      this.arraySub = false;
    },

    disabledSub(sub) {
      if (this.$route.params.submission) {
        if (sub === this.$route.params.submission.id && localStorage.code) {
          return true;
        }
      } else {
        return false;
      }
    },

    sendForSignature(sub) {
      this.disabledButton = true;
      window.axios
        .post("/api/requestSignature/" + sub.id, {
          recipients: JSON.stringify(this.recipients),
          newCode: this.$route.params.code,
          trackId: this.$route.params.trackId
        })
        .then(response => {
          console.log(response.data);
          localStorage.removeItem("email");
          localStorage.removeItem("code");
          this.disabledButton = false;
        });
    },

    checkDate(date) {
      if (date.toLowerCase().includes("date")) {
        return true;
      }
    },

    editSubmission(sub) {
      let tracker = this.$route.params.trackId;

      var queryString = $("#mySubmission input:text").serializeArray(); // store json object

      $("#mySubmission input:checkbox").each(function(i, e) {
        queryString.push({
          name: e.name,
          value: e.checked ? "Yes" : "Off",
          box: true
        });
      });

      window.axios
        .post("/api/updateSubmission/" + sub.id, {
          queryString: queryString,
          trackId: tracker
        })
        .then(() => {
          this.dialog = false;
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Updating Submission...",
            showConfirmButton: false,
            timer: 3500
          });
          this.closeDialogSub();
          this.getMenuItems();
          this.$store.dispatch("getUser");
          this.$router.push({ name: "Clients" });
        });
    },

    updateSubmissions() {
      window.axios.get("/api/userSubmissions").then(response => {
        console.log(response.data);
      });
    },

    getMenuItems() {
      window.axios.get("/api/menuItems").then(response => {
        this.items = response.data;
      });
    },

    displayPolicy(submission) {
      this.showPolicy = !this.showPolicy;
      this.selectedSubmission = submission;
    },

    alertAdmin() {
      this.valueLoading = true;
      window.axios
        .post("/api/envelopeSub/" + this.selectedSubmission.id, {
          menuType: this.menuType
        })
        .then(response => {
          this.valueLoading = false;
          console.log(response.data);
          this.showPolicy = false;
          this.hideButton = false;
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Successfully sent!",
            showConfirmButton: false,
            timer: 1500
          });
          this.$emit("update");
        });
      //

      //window.
    },

    formatDate(date) {
      return moment(date).format("MMMM Do YYYY");
    },

    displayWelcome() {
      this.$emit("showWelcome");
    },

    openDocument(doc) {
      this.singleDoc = doc;
      this.dialog2 = true;
      // this.dialog2 = !this.dialog2;
      //$("#selectDay").modal("show");
    },

    openDocument2(doc) {
      this.singleDoc = doc;
      this.dialog = true;
      // $("#selectDay").modal("show");
    },

    closeDocModal() {
      this.dialog2 = false;
      this.singleDoc = "";
      //this.getDocuments();
    },

    closeDocModalFinal() {
      this.dialog = false;
      this.singleDoc = "";
      //this.getDocuments();
    }
  }
};
</script>
<style scoped>
@media screen and (orientation: portrait) {
  #toolbar {
    width: 100%;
  }
}
</style>
